export default __webpack_public_path__ + "static/mulesoft-490adf8a0e20f1b7de19ac7a24f493e1.png";